<template>
  <div v-if="apps.length"
       class="associated-apps">
    <ul class="associated-list">
      <li v-for="(app, key) in apps"
          :key="key"
          class="app">
        <div class="chain-block">
          <div class="line top-line"></div>
          <icon-app-link width="15"
                         height="15" />
          <div :style="getAppStyles(app)"
               class="app-icon line"></div>
        </div>
        <div class="app-name one-liner">
          {{ app.en.label }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import osPlaceholders from '@/constants/osPlaceholders.js'

  export default {
    props: {
      apps: {
        type: Array,
        default: () => []
      },

      platform: {
        type: String,
        required: true
      }
    },

    methods: {
      getAppStyles(app) {
        let image = app.icon_url
        let size = 'cover'
        let border = 'none'

        if (!image) {
          image = osPlaceholders[this.platform]
          border = '1px solid #979797'
          size = '70%'
        }

        return {
          'background-image': 'url(' + image + ')',
          'background-size': size,
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'border': border
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .associated-apps {
    .associated-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .app {
      display: flex;
      align-items: flex-end;

      padding: 0 8px;

      .chain-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        margin: 0;

        .app-icon {
          width: 22px;
          height: 22px;
          border-radius: 50%;
        }

        .top-line {
          margin-bottom: -10px;
          height: 12px;
        }

        .line {
          margin-top: 8px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            top: -50%;
            left: 50%;

            width: 0;
            height: 8px;
            border-left: 1px solid #979797;
          }
        }
      }

      .app-icon {
        width: 22px;
        height: 22px;
        
        border-radius: 50%;
      }

      .app-name {
        font-size: 14px;
        margin: 0 0 0 6px;
      }
    }
  }
</style>
